import { render, staticRenderFns } from "./SimulationCard.vue?vue&type=template&id=c2ad64e0&scoped=true&"
import script from "./SimulationCard.vue?vue&type=script&lang=js&"
export * from "./SimulationCard.vue?vue&type=script&lang=js&"
import style0 from "./SimulationCard.vue?vue&type=style&index=0&id=c2ad64e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ad64e0",
  null
  
)

export default component.exports